var app = angular.module('leonardo');

var UserListFilter = function ($filter) {
  return function (list) {
    if (!list || list.length === 0) return 'Not assigned';
    var users = [];
    angular.forEach(list, function(user) {
      users.push($filter('username')(user));
    });
    return users.join(', ');
  }
};

app.filter('user_list', ['$filter', UserListFilter]);
